// A SZERKESZTŐ-MÓD ESZKÖZTÁRA. Desktopon a fejléc jobb oldalán: „Csempe hozzáadása" · „Alapértelmezés visszaállítása" ·
// Mégse · Mentés. Mobilon (375 px) RAGADÓS ALSÓ SÁV: Mégse | Mentés, a másik kettő egy „…" menüben — a tartalom kap egy
// alsó paddinget (a hívó), hogy a sáv ne takarjon semmit.
import { EllipsisHorizontalIcon, PlusIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

export interface EditorToolbarProps {
  dirty: boolean;
  saving: boolean;
  onAdd: () => void;
  onReset: () => void;
  onCancel: () => void;
  onSave: () => void;
}

/** Desktop: a fejléc akció-sora. */
export function EditorHeaderActions({
  dirty,
  saving,
  onAdd,
  onReset,
  onCancel,
  onSave,
}: EditorToolbarProps): JSX.Element {
  const { t } = useTranslation();
  return (
    <div className="hidden flex-wrap items-center justify-end gap-2 md:flex">
      <Button variant="outline" onClick={onAdd}>
        <PlusIcon aria-hidden />
        {t('dashboard.editor.addTile')}
      </Button>
      <Button variant="outline" onClick={onReset}>
        {t('dashboard.editor.reset')}
      </Button>
      <Button variant="outline" onClick={onCancel}>
        {t('dashboard.editor.cancel')}
      </Button>
      <Button variant="brand" disabled={!dirty || saving} onClick={onSave}>
        {t('dashboard.editor.save')}
      </Button>
    </div>
  );
}

/** Mobil: ragadós alsó sáv. */
export function EditorBottomBar({
  dirty,
  saving,
  onAdd,
  onReset,
  onCancel,
  onSave,
}: EditorToolbarProps): JSX.Element {
  const { t } = useTranslation();
  return (
    <div
      data-testid="editor-bottom-bar"
      className="app-fixed-bottom border-border bg-card/95 fixed inset-x-0 bottom-0 z-40 flex items-center gap-2 border-t px-4 pb-[calc(0.75rem+env(safe-area-inset-bottom))] pt-3 backdrop-blur md:hidden"
    >
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" size="icon" aria-label={t('dashboard.editor.moreActions')}>
            <EllipsisHorizontalIcon aria-hidden />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start" side="top">
          <DropdownMenuItem onSelect={onAdd}>{t('dashboard.editor.addTile')}</DropdownMenuItem>
          <DropdownMenuItem onSelect={onReset}>{t('dashboard.editor.reset')}</DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <Button variant="outline" className="flex-1" onClick={onCancel}>
        {t('dashboard.editor.cancel')}
      </Button>
      <Button variant="brand" className="flex-1" disabled={!dirty || saving} onClick={onSave}>
        {t('dashboard.editor.save')}
      </Button>
    </div>
  );
}
